import { render } from "./capa_template_manager.vue?vue&type=template&id=e3d0215a&scoped=true"
import script from "./capa_template_manager.vue?vue&type=script&lang=js"
export * from "./capa_template_manager.vue?vue&type=script&lang=js"

import "./capa_template_manager.vue?vue&type=style&index=0&id=e3d0215a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3d0215a"]])

export default __exports__